import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdDisplay04 = (props) => {
  return <LSBdDisplay04Wrapper {...props} />;
};

export default LSBdDisplay04;

const LSBdDisplay04Wrapper = styled(LineSeedKrBd)`
  font-size: 40px;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: -0.6px;

  color: #222222;
`;
